export default __webpack_public_path__ + "static/media/leomange.0270966b.png";